export default "__VITE_ASSET__DdKiAwju__"